import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { ParagraphsHolderModule } from '@big-direkt/paragraphs-holder';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { DirectoryAnchorListItem, ScrollService } from '@big-direkt/utils/environment';
import { IconBigMediumPfeilUnten, IconBigMediumPlus, IconComponent } from '@big-direkt/utils/icons';
import { ParagraphModel } from '@big-direkt/utils/shared';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'big-directory',
    templateUrl: './directory.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, ParagraphsHolderModule, TranslocoPipe, UiButtonComponent],
})
export class DirectoryComponent {
    private readonly scrollService = inject(ScrollService);

    public readonly iconArrow = IconBigMediumPfeilUnten;
    public readonly iconPlus = IconBigMediumPlus;
    public readonly maxItemsToShow = 8;

    public readonly paragraphs = input<ParagraphModel[]>();
    public readonly directoryParagraphs = input<ParagraphModel[]>();

    public readonly anchorListIsExpanded = signal(false);

    public readonly anchorList = computed(() => {
        const paragraphs = this.paragraphs();

        if (!paragraphs?.length) {
            return [];
        }

        return this.buildAnchorList(paragraphs);
    });

    public readonly limitedAnchorListItems = computed(() => {
        const items = this.anchorList();

        return this.anchorListIsExpanded() ? items : items.slice(0, this.maxItemsToShow);
    });

    public onClick(elementId: string): void {
        const scrollSelector = `#${elementId}`;
        this.scrollService.scroll(scrollSelector, { spaceToHeaderParam: 0 });
    }

    private buildAnchorList(paragraphs: ParagraphModel[]): DirectoryAnchorListItem[] {
        const anchorList: DirectoryAnchorListItem[] = [];

        paragraphs.forEach(paragraph => {
            if (!paragraph.directoryTitle || !paragraph.id) {
                return;
            }

            anchorList.push({
                title: paragraph.directoryTitle,
                anchorId: paragraph.id,
            });
        });

        return anchorList;
    }
}
